'use client';

import Image from 'next/image';
import Button from '@/app/cc/_component/ui/common/Button/Button';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/Applications/Applications.module.scss';
import { useOpenModal } from '@/app/cc/_hooks/useOpenModal';
import { useGetDealType } from '@/app/cc/_stores/useDealTypeStore';
import { sendGA } from '@/app/cc/_util/sendGA';

export default function Application() {
  const dealType = useGetDealType();
  const openModal = useOpenModal();
  return (
    <section className={styles.application}>
      <div className={styles.inner}>
        <div className={styles.content}>
          <Text as="h3" category="title" variant="b1" color="var(--color-gray-0)">
            <Text as="span" category="title" variant="b1" color="var(--color-primary-500)">
              가장 완벽한 안심,
            </Text>
            <br className="break" /> 지금 바로 준비하세요
          </Text>
          <Text as="p" category="body" variant="r2" color="var(--color-gray-0)">
            소중한 {dealType === 'sale' ? '자산' : '보증금'}, &apos;설마&apos;하는 순간에 사라질 수 있습니다.
            <br />
            이실장 안심케어로 법적 보호막을 하나 더 만드세요.
          </Text>
        </div>
        <div className={styles.buttonContent}>
          <Button
            className={styles.ApplicationButton}
            type="button"
            size="xl"
            color="primary"
            variant="fill"
            onClick={() => {
              sendGA('lowReserveClick');
              openModal('consultation');
            }}
          >
            상담 신청하기
            <div className={styles.arrowIcon}>
              <Image src="/cc/image/right_arrow.svg" alt="arrow_right" width={8.25} height={14.6} />
            </div>
          </Button>
        </div>
      </div>
    </section>
  );
}
